<template>
    <div id="paper-root" style="max-width: 1200px;margin: 0 auto;">
        <a-layout theme="light" class="paper-style-2">
            <a-layout v-show="examStatus == 1">
                <a-drawer title="题目列表" placement="bottom" :closable="false" :visible="drawerStatus"
                    @close="drawerStatus = false">
                    <a-row>
                        <a-col :span="14">
                            <span>正确&nbsp;</span><a-tag color="green">&nbsp;</a-tag>
                            <span>错误&nbsp;</span><a-tag color="red">&nbsp;</a-tag>
                            <span>未答&nbsp;</span><a-tag>&nbsp;</a-tag>
                        </a-col>
                    </a-row>
                    <div v-for="(q, i) in paperQuestion" :key="i" style="float: left;margin-top: 8px;">
                        <a-tag :color="isWriteAnswer(i) ? q.questionScore==q.gotScore? 'green' : 'red' : ''" @click="jumpQuestion(i)">{{ i + 1 }}</a-tag>
                    </div>
                </a-drawer>
                <div class="headerBox">
                    <p class="djs_box" style="color: #666;"> 
                        <span style="padding-right: 10px;">总分:{{ paperInfo.totalScore }}</span>
                        <span>得分:{{ userPaperInfo.gotScore }}</span>
                    </p>
                    <div>
                        <div class="dtk_button" @click.stop="drawerStatus = true">
                        <i class="iconfont">&#xe614;</i><span>答题卡</span>   
                        </div>
                    </div>
                </div>
                <a-layout-content>
                    <!-- 一页一题样式 -->
                    <div class="paper-content" :bordered="false">
                        <div class="paper-content-item" v-show="qi == currentQuestionIndex" v-for="(q, qi) in paperQuestion"
                            :key="qi">
                            <a-row>
                                <a-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                                    <a-card class="stem-card" :bordered="false" :headStyle="{ 'background': '#c8c8c84a' }"
                                        :bodyStyle="{ 'background': '#c8c8c84a' }">
                                        <span slot="title">
                                            <span>{{ getQuestionTypeText(q.questionType) }}</span>
                                        </span>
                                        <div class="question-stem">
                                            <p style="float: left;">{{ qi + 1 }}、</p>
                                            <div style="float: left;" v-html="q.questionStem" :id="'question-stem-' + q.id">
                                            </div>
                                        </div>
                                    </a-card>
                                </a-col>
                                <a-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                                    <a-card class="answer-card" title="" :bordered="false"
                                        :headStyle="{ 'background': '#c8c8c84a' }"
                                        :bodyStyle="{ 'background': '#c8c8c84a' }" v-if="paperAnswer.length > 0">
                                        <!-- 单选 -->
                                        <a-radio-group class="question-radio" :disabled="examStatus != 1"
                                            v-if="q.questionType == 1" v-model="paperAnswer[qi]['myAnswer']">
                                            <a-radio disabled  v-for="(o, oi) in q.questionOptions" :key="oi" :value="oi">
                                                <div class="radio-content">
                                                    <span class="question-letter">{{ index2letter(oi) }}
                                                    </span>
                                                    <div class="question-options-content">
                                                        <div class="option" v-html="o.item"></div>
                                                    </div>
                                                </div>
                                            </a-radio>
                                        </a-radio-group>
                                        <!-- 多选 -->
                                        <a-checkbox-group class="question-checkbox" :disabled="examStatus != 1"
                                            v-if="q.questionType == 2" v-model="paperAnswer[qi]['myAnswer']">
                                            <a-checkbox disabled  v-for="(o, oi) in q.questionOptions" :key="oi" :value="oi">
                                                <div class="checkbox-content">
                                                    <span class="question-letter">{{ index2letter(oi) }}
                                                    </span>
                                                    <div class="question-options-content">
                                                        <div class="option" v-html="o.item"></div>
                                                    </div>
                                                </div>
                                            </a-checkbox>
                                        </a-checkbox-group>
                                        <!-- 判断题 -->
                                        <a-radio-group class="question-switch" :disabled="examStatus != 1"
                                            v-if="q.questionType == 3" v-model="paperAnswer[qi]['myAnswer']">
                                            <a-radio disabled  value="true">
                                                <div class="radio-content">
                                                    <span class="question-letter">{{ index2letter(0) }}</span>
                                                    <span>{{ $t('exam.right') }}</span>
                                                </div>
                                            </a-radio>
                                            <a-radio value="false">
                                                <div class="radio-content">
                                                    <span class="question-letter">{{ index2letter(1) }}</span>
                                                    <span>{{ $t('exam.wrong') }}</span>
                                                </div>
                                            </a-radio>
                                        </a-radio-group>
                                        <!-- 填空题 -->
                                        <div class="question-fill-wrap" v-if="q.questionType == 4">
                                            <a-input class="question-fill" disabled  :readOnly="examStatus != 1"
                                                v-for="oi in q.questionOptions.fillGapNum" :key="oi"
                                                v-model="paperAnswer[qi]['myAnswer'][oi - 1]" :addonBefore="'第' + oi + '空'"
                                                :placeholder="'请填写第' + oi + '空回答'" />
                                        </div>
                                        <!-- 主观题 阅读分析-->
                                        <div class="question-read" v-if="q.questionType == 5 || q.questionType == 6">
                                            <a-textarea disabled  :readOnly="examStatus != 1" :auto-size="{ minRows: 5, maxRows: 20 }"
                                                :placeholder="$t('exam.answerArex')"
                                                v-model="paperAnswer[qi]['myAnswer']"></a-textarea>
                                        </div>
                                        <p style="padding: 10px 0;font-size: 14px;color: #666;">正确答案：{{answer2Text(paperQuestion[qi])}}</p>
                                        <!-- 控制条 -->
                                        <div class="question-opt-btn">
                                            <div class="switch-btn">
                                                <a-button class="prevBtn" type="primary"
                                                    @click="prevQuestion">上一题</a-button>
                                                <a-button class="nextBtn" type="primary"
                                                    @click="nextQuestion">下一题</a-button>
                                            </div>
                                        </div>

                                        <p></p>
                                    </a-card>
                                </a-col>
                               
                            </a-row>
                        </div>

                    </div>
                </a-layout-content>
            </a-layout>
        </a-layout>
    </div>
</template>
  
<script>
import Vue from 'vue'
import { getAction, postAction, postActionWithParam } from '@/api/manage'
import { mixinDevice } from '@/utils/mixin.js'
import { jumpMixins } from "@/utils/jumpMixins"
import { examMixins } from '@/utils/examMixins'
import { upload2Qiniu, dataURLtoBlob } from '@/utils/qiniu.js'
import JModal from '@/components/jeecg/JModal'
import Voice from '@/components/tools/Voice'

export default {
    name: 'Examine',
    mixins: [mixinDevice, jumpMixins, examMixins],
    components: {
        JModal,
        Voice
    },
    data() {
        return {
            heightOffset: 0,
            paperId: '',
            departId: '',
            paperDeptId: '',
            eventApplyId: '', //报名ID
            eventApplyCategory: '', //报名赛项
            userPaperList: [],
            loadingUserPaperList: false,
            userPaperInfo: {}, //用户答题卡信息
            paperQuestion: [], //已经过转换的题目信息
            questionSections: {},//题目分类信息
            paperAnswer: [], // 答题卡信息
            undoCount: 0, //未作答题目数量
            isCurrentQuestionChange: false, // 当前题目是否已修改
            userPaperId: '', // 答题卡ID
            paperDescVisible: false, //试卷介绍是否可见
            selectPaperVisible: false, //选择试卷modal
            cameraList: [],
            currentCamera: '',
            mediaRecorder: null,
            screenRecorder: null,
            duration: 0, //用时
            remaining: 0, //剩余时间
            remainTimeText: '',
            examStatus: 1, //考试状态 -1预览 0已结束 1正在考试
            canRequestQustion: true, //是否可以请求题目
            canSave: true, //防止保存试卷高频点击
            canSubmit: true, //防止提交试卷高频点击
            isRequestMyPaperQuestion: false, //是否已请求试卷
            isSaved: false, //答题是否已保存
            drawerStatus: false,   //答题卡
            paperInfo:{}
        }
    },
    watch: {
        currentQuestionIndex(newValue, oldValue) {
            if (this.isCurrentQuestionChange && this.isWriteAnswer(oldValue)) {
                this.submitOneAnswer(oldValue)
            }
            this.isCurrentQuestionChange = false
        }
    },
    created() {
        let that = this
        this.getUserPaperInfo(this.$route.query.id)

    },
    mounted() {
        var that = this

    },
    beforeRouteLeave(to, from, next) {
        next()
    },
    //离开页面
    beforeDestroy() {

    },
    methods: {
        //获取答卷
        getUserPaperInfo(id) {
            this.paperQuestion = []
            return getAction(`/teaching/teachingPaper/getUserPaper?userPaperId=${id}`).then((res) => {
                if (res.success && res.result != null) {
                    this.paperInfo = res.result.paper
                    this.userInfo = res.result.userInfo
                    this.userPaperInfo = res.result.userPaper
                    this.paperDepart = res.result.paperDepart
                    let questions = res.result.question
                    this.parseQuestion(questions)
                } else {
                    this.$message.error(res.message)
                }
            })
        },
        parseQuestion(questions) {
            let currentSection = null;
            for (let qi in questions) {
                let q = questions[qi]
                console.log("parse question:", q);
                //解析题目分类

                if (q.questionSection) {
                    currentSection = qi
                    this.questionSections[qi] = {
                        text: q.questionSection,
                        count: 0,
                        score: 0
                    }
                }
                if (currentSection != null) {
                    this.questionSections[currentSection].count += 1;
                    this.questionSections[currentSection].score += q.questionScore;
                }

                if (q.questionOptions != null) {
                    q.questionOptions = JSON.parse(q.questionOptions)
                }
                this.paperQuestion.push(q)

                this.paperAnswer.push({
                    id: q.id,
                    qid: q.questionId,
                    gotScore: q.gotScore,
                    reviewComment: q.reviewComment,
                    myAnswer: this.parseAnswer(q.questionType, q.myAnswer),
                    myAnswerFile: q.myAnswerFile
                })
                //渲染填空题dom
                if (q.questionType == 4) {
                    this.renderGapFillingStemDom(q, qi)
                }
            }
        },
        nextQuestion() {
            window.document.dispatchEvent(new CustomEvent('viocePause'));
            if (this.currentQuestionIndex == this.paperQuestion.length - 1) {
                return
            }
            this.currentQuestionIndex++
        },
        prevQuestion() {
            window.document.dispatchEvent(new CustomEvent('viocePause'));
            if (this.currentQuestionIndex == 0) {
                return
            }
            this.currentQuestionIndex--
        },
    },
}
</script>
<style lang="less" scoped>
@import url('../../assets/exam.less');
</style>